import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Box,
  TextField,
  Typography,
  Button,
  IconButton,
  InputAdornment,
  Tooltip,
  Avatar,
  Select,
} from "@mui/material";
import { useMutation } from "@apollo/client";
import imageCompression from "browser-image-compression";
//Icons
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../Style/dialogstyle.scss";
import EmptyImage from "../../Assets/empty-image.png";
import { AuthContext } from "../../Context/AuthContext";
import CropImageFile from "../CropImage/CropImageFile";
import { CREATE_MATERIAL_NAME } from "../../Schema/MaterialName";
import {
  SelectUnit,
  SelectCategory,
  SelectGroup,
} from "../Include/DynamicSelect";

export default function CreateMaterialName({ open, handleClose, setRefetch }) {
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [unitVal, setUnitVal] = useState({ id: "", title: "" });
  const [categoryVal, setCategoryVal] = useState({ id: "", title: "" });
  const [groupVal, setGroupVal] = useState({ id: "", title: "" });

  // ========================= upload Image =========================
  const [profileHook, setProfileHook] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [photoURL, setPhotoURL] = useState(null);
  const [openCrop, setOpenCrop] = useState(false);

  const handleUploadImage = async (e) => {
    const imageFile = e.target.files[0];

    const options = {
      maxSizeMB: 0.5,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };
    const compressedFile = await imageCompression(imageFile, options);
    var newFile = new File([compressedFile], `${imageFile.name}.png`, {
      type: "image/png",
    });

    // console.log("newFile::", newFile);

    if (newFile) {
      setImageFile(newFile);
      setPhotoURL(URL.createObjectURL(newFile));
      setOpenCrop(true);
    }
  };

  //hiden and show vibility
  const [show, setShow] = useState(false);
  const handleClick = () => setShow(!show);

  const [createMaterialName] = useMutation(CREATE_MATERIAL_NAME, {
    onCompleted: ({ createMaterialName }) => {
      setLoading(false);
      // console.log("createMaterialName::", createMaterialName);
      if (createMaterialName?.status) {
        setAlert(true, "success", createMaterialName?.message);
        handleClose();
        resetForm();
        // setRefetch();
        setGroupVal({ id: "", title: "" });
        setCategoryVal({ id: "", title: "" });
        // setUnitVal({ id: "", title: "" });
      } else {
        setAlert(true, "error", createMaterialName?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    categoryId: Yup.string().required("ទាមទារ!"),
    materialEnName: Yup.string().required("ទាមទារ!"),
    materialKhName: Yup.string().required("ទាមទារ!"),
    groupId: Yup.string().required("ទាមទារ!"),
    remark: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      categoryId: "",
      materialEnName: "",
      materialKhName: "",
      remark: "",
      groupId: "",
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      // console.log("values:::", values);
      setLoading(true);
      createMaterialName({
        variables: {
          input: {
            materialEnName: values?.materialEnName,
            materialKhName: values?.materialKhName,
            remark: values?.remark,
            categoryId: values?.categoryId,
            groupId: values?.groupId,
          },
        },
      });
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    resetForm,
    setFieldValue,
  } = formik;

  //   useEffect(() => {
  //     if (unitVal?.id) {
  //       setFieldValue("unitId", unitVal?.id)
  //     }
  //   }, [unitVal?.id])

  useEffect(() => {
    if (categoryVal?.id) {
      setFieldValue("categoryId", categoryVal?.id);
    }
  }, [categoryVal?.id]);

  useEffect(() => {
    if (groupVal?.id) {
      setFieldValue("groupId", groupVal?.id);
    }
  }, [groupVal?.id]);

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="sm">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">បង្កើតឈ្មោះសម្ភារៈ</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              {/* <Grid item xs={12}>
                {!openCrop ? (
                  <Box>
                    <Stack direction="row" justifyContent="center">
                      <Tooltip title="click to upload">
                        <Button component="label" className="btn-upload-user">
                          <TextField
                            type="file"
                            id="image"
                            sx={{ display: "none" }}
                            onChange={handleUploadImage}
                          />
                          <Avatar
                            className="avater-image"
                            src={
                              imageFile
                                ? URL.createObjectURL(imageFile)
                                : EmptyImage
                            }
                          />
                        </Button>
                      </Tooltip>
                    </Stack>
                  </Box>
                ) : (
                  <CropImageFile
                    openCrop={openCrop}
                    setOpenCrop={setOpenCrop}
                    photoURL={photoURL}
                    setPhotoURL={setPhotoURL}
                    setImageFile={setImageFile}
                    setProfileHook={setProfileHook}
                  />
                )}
                <Typography
                  className="field-title"
                  sx={{ textAlign: "center", marginTop: "10px" }}
                >
                  រូបភាព
                </Typography>
              </Grid> */}

              <Grid item xs={6}>
                <Typography className="field-title">សម្ភារៈជាខ្មែរ</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  placeholder="សម្ភារៈជាខ្មែរ"
                  {...getFieldProps("materialKhName")}
                  error={Boolean(
                    touched.materialKhName && errors.materialKhName
                  )}
                  helperText={touched.materialKhName && errors.materialKhName}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography className="field-title">
                  សម្ភារៈជាអង់គ្លេស
                </Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  placeholder="សម្ភារៈជាអង់គ្លេស"
                  {...getFieldProps("materialEnName")}
                  error={Boolean(
                    touched.materialEnName && errors.materialEnName
                  )}
                  helperText={touched.materialEnName && errors.materialEnName}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography className="field-title">ប្រភេទ</Typography>
                <SelectCategory
                  selectedVal={categoryVal}
                  setSelectedVal={setCategoryVal}
                  isUse={true}
                />
              </Grid>

              <Grid item xs={6}>
                <Typography className="field-title">ក្រុម</Typography>
                <SelectGroup
                  isUse={true}
                  selectedVal={groupVal}
                  setSelectedVal={setGroupVal}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography className="field-title">Remark</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  multiline
                  rows={3}
                  size="small"
                  placeholder="remark"
                  {...getFieldProps("remark")}
                  error={Boolean(touched.remark && errors.remark)}
                  helperText={touched.remark && errors.remark}
                />
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    កំពុងដំណើរការ...
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    បង្កើត
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
